import {useEffect, useState} from 'react';

import {getTopBeers} from 'services/beers';
import {Beer} from 'typescript/models/Beer';
import Brewery from 'typescript/models/Brewery';

export const useTopBeers = (): [Beer[], {[key: string]: Brewery}, boolean] => {
  const [topBeers, setTopBeers] = useState<Beer[]>([]);
  const [beersIncluded, setBeersIncluded] = useState<{[key: string]: Brewery}>({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const topBeersResponse = await getTopBeers();

      const beersIncluded: {[key: string]: Brewery} = {};
      topBeersResponse.data.included.forEach((item: Brewery) => {
        beersIncluded[item.id] = item;
      });

      setTopBeers(topBeersResponse.data.data);
      setBeersIncluded(beersIncluded);
      setIsLoading(false);
    })();
  }, []);

  return [topBeers, beersIncluded, isLoading];
};
